<template>
	<div id="app">
		<b-navbar class="navbar-dark bg-dark fixed-top navbar-font" toggleable="lg">
			<div class="container">
				<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
				<b-collapse is-nav id="nav_collapse">
					<b-navbar-nav fill class="w-100">
						<b-nav-item v-scroll-to="'#page-top'" class="navbar-item">Home</b-nav-item>
						<b-nav-item v-scroll-to="'#whatwedo'" class="navbar-item">What we do</b-nav-item>
						<b-nav-item v-scroll-to="'#products'" class="navbar-item">The Planet</b-nav-item>
						<b-nav-item v-scroll-to="'#applications'" class="navbar-item">Performance</b-nav-item>
						<b-nav-item v-scroll-to="'#about'" class="navbar-item">About us</b-nav-item>
						<b-nav-item v-scroll-to="'#partners'" class="navbar-item">Partners</b-nav-item>
						<b-nav-item v-scroll-to="'#contact'" class="navbar-item">Contact</b-nav-item>
					</b-navbar-nav>
				</b-collapse>
			</div>
		</b-navbar>

		<div id="page-top" class="jumbotron foto1">
			<div class="container">
				<div class="row">
					<div class="col-4 col-sm-4 col-md-3">
						<img class="img-fluid logo-top" src="images/xplorex logo white.jpg" />
					</div>
					<div class="col-7 col-sm-7 col-md-5 offset-md-4">
						<img class="img-fluid planet-top" src="images/planet_logo_shadow.png" />
					</div>
					<!-- <div class="col-sm-6 offset-sm-1 col-xs-8 planet-top">
						<img class="img-fluid" src="images/planet_logo.png">
					</div>-->
				</div>
			</div>
		</div>

		<section class="pt-60" id="whatwedo">
			<div class="container">
				<div class="row mt-4">
					<div id="whatwedo-title" class="col-md-12" contenteditable="false" v-html="quarkRead('whatwedo-title')"></div>
					<div id="whatwedo-content" class="col-md-12" contenteditable="false" v-html="quarkRead('whatwedo-content')"></div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<h2>Latest video; Brixlegg archeological site</h2>
						<br />
					</div>
					<div class="col-md-6">
						<img class="img-fluid" :src="movie[3].poster" alt="movie1" @click="playMovie(3)" />
						<br />
						<br />
						<p>The planet; the portable high resolution diffractometer from xplorex is used at an archeological site to investigate a Copper mine from the bronze age.</p>
					</div>
					<div class="col-md-4">
						<a href="/pdf/appnote4-Archeology.pdf">
							<img class="img-fluid border" src="/pdf/appnote4-Archeology.jpg" />
						</a>
					</div>
				</div>
				<div class="row my-4">
					<div class="col-md-12">
						<h2>
							<a v-scroll-to="'#about'" href="#">Click here for our other videos</a>
						</h2>
					</div>
				</div>
			</div>
		</section>

		<div class="jumbotron foto2"></div>

		<!-- products -->

		<section class="pt-60" id="products">
			<div class="container">
				<div class="row mt-4">
					<div id="products-title" class="col-md-12" contenteditable="false" v-html="quarkRead('products-title')"></div>
				</div>
				<div class="row">
					<div id="products-content" class="col-md-6" contenteditable="false" v-html="quarkRead('products-content')"></div>
					<div class="col-md-5 offset-md-1">
						<carousel ref="carousel" :perPage="1" :autoplay="true" :loop="true">
							<slide>
								<div>
									<h2>Application Note #1</h2>
									<!-- <p class="text-center">X-ray analysis of Zirconium oxide</p> -->
									<a href="/pdf/appnote1-ZrO.pdf">
										<img class="img-fluid border" src="/pdf/appnote1-ZrO-1.jpg" />
									</a>
								</div>
							</slide>
							<slide>
								<div>
									<h2>Application Note #2</h2>
									<!-- <p class="text-center">Identification of MnCO3</p> -->
									<a href="/pdf/appnote2-MnCO3.pdf">
										<img class="img-fluid border" src="/pdf/appnote2-MnCO3-1.jpg" />
									</a>
								</div>
							</slide>
							<slide>
								<div>
									<h2>Application Note #3</h2>
									<!-- <p class="text-center">Resolution of the planet</p> -->
									<a href="/pdf/appnote3-Resolution_of_the_planet.pdf">
										<img class="img-fluid border" src="/pdf/appnote3-Resolution_of_the_planet-1.jpg" />
									</a>
								</div>
							</slide>
							<slide>
								<div>
									<h2>Application Note #4</h2>
									<!-- <p class="text-center">Resolution of the planet</p> -->
									<a href="/pdf/appnote4-Archeology.pdf">
										<img class="img-fluid border" src="/pdf/appnote4-Archeology.jpg" />
									</a>
								</div>
							</slide>
							<slide>
								<div>
									<h2>Application Note #5</h2>
									<!-- <p class="text-center">Resolution of the planet</p> -->
									<a href="/pdf/appnote5-Energetic-material1.pdf">
										<img class="img-fluid border" src="/pdf/appnote5-Energetic-material1.jpg" />
									</a>
								</div>
							</slide>
						</carousel>
					</div>
				</div>
			</div>
		</section>

		<div class="jumbotron foto3"></div>

		<!-- applications -->

		<section class="pt-60" id="applications">
			<div class="container">
				<div class="row mt-4">
					<div id="applications-title" class="col-md-12" contenteditable="false" v-html="quarkRead('applications-title')"></div>
				</div>
				<div class="row">
					<div id="applications-ref1" class="col-md-3" contenteditable="false" v-html="quarkRead('applications-ref1')"></div>
					<div id="applications-ref2" class="col-md-3" contenteditable="false" v-html="quarkRead('applications-ref2')"></div>
					<div id="applications-ref3" class="col-md-3" contenteditable="false" v-html="quarkRead('applications-ref3')"></div>
					<div id="applications-ref4" class="col-md-3" contenteditable="false" v-html="quarkRead('applications-ref4')"></div>
				</div>

				<div class="row">
					<div class="col-md-3">
						<v-gallery :images="measurements0"></v-gallery>
						<!-- <img class="img-fluid" :src="measurements0[0].url" alt="silicon" @click="showGallery(0)" /> -->
					</div>
					<div class="col-md-3">
						<v-gallery :images="measurements1"></v-gallery>
						<!-- <img class="img-fluid" :src="measurements1[0].url" alt="resolution1" @click="showGallery(1)" />
						<img class="img-fluid" :src="measurements1[1].url" alt="resolution2" @click="showGallery(2)" />-->
					</div>
					<div class="col-md-3">
						<v-gallery :images="measurements2"></v-gallery>
						<!-- <img class="img-fluid" :src="measurements2[0].url" alt="halite" @click="showGallery(3)" />
						<img class="img-fluid" :src="measurements2[1].url" alt="calcite" @click="showGallery(4)" />-->
					</div>
					<div class="col-md-3">
						<v-gallery :images="measurements3"></v-gallery>
						<!-- <img class="img-fluid" :src="measurements3[0].url" @click="showGallery(5)" />
						<img class="img-fluid" :src="measurements3[1].url" @click="showGallery(6)" />-->
					</div>
				</div>
			</div>
		</section>

		<div class="jumbotron foto4"></div>

		<!-- about us -->

		<section class="pt-60" id="about">
			<div class="container">
				<div class="row mt-4">
					<div id="about-title" class="col-md-12" contenteditable="false" v-html="quarkRead('about-title')"></div>
				</div>
				<div class="row mb-5">
					<div id="about-content" class="col-md-6" contenteditable="false">
						<p>xplorex GmbH develops and produces X-ray analytical systems, for quick analysis on-site.</p>
						<p>The company is a joint venture of three parties:</p>
						<p>&nbsp;</p>
						<div class="row">
							<div class="col-md-4 d-flex align-items-center">
								<a href="http://www.xhuber.com" target="_blank">
									<img class="img-fluid p-3" src="images/logo-huber.jpg" />
								</a>
							</div>
							<div class="col-md-4 d-flex align-items-center">
								<a href="http://www.focussing.nl" target="_blank">
									<img class="img-fluid p-3" src="images/logo-focussing.png" />
								</a>
							</div>
							<div class="col-md-4 d-flex align-items-center">
								<a href="http://www.ajk-analytical.com" target="_blank">
									<img class="img-fluid p-3" src="images/logo-ajk.jpg" />
								</a>
							</div>
						</div>
						<p>&nbsp;</p>
						<p>Together we represent more than 50 years of experience in X-ray diffraction.</p>
					</div>
					<div class="col-md-6">
						<img class="img-fluid" :src="movie[2].poster" alt="movie3" @click="playMovie(2)" />
					</div>
				</div>
			</div>

			<div class="container">
				<div class="row mb-3">
					<div class="col-md-12">
						<h2>Look at our videos!</h2>
						<br />
					</div>
					<div class="col-md-6">
						<img class="img-fluid" :src="movie[0].poster" alt="movie1" @click="playMovie(0)" />
					</div>
					<div class="col-md-6">
						<img class="img-fluid" :src="movie[1].poster" alt="movie2" @click="playMovie(1)" />
					</div>
				</div>
			</div>
		</section>

		<!-- partners -->

		<section class="altWrap pt-60" id="partners">
			<div class="container">
				<div class="row mt-4">
					<div id="partners-title" class="col-md-12" contenteditable="false">
						<h1>PARTNERS</h1>
					</div>
				</div>
				<div class="row">
					<div id="partners-content1" class="col d-flex align-items-center" contenteditable="false">
						<a href="http://www.dectris.com" target="_blank">
							<img class="img-fluid p-3" src="images/logo-dectris.png"/>
						</a>
					</div>
					<div id="partners-content2" class="col d-flex align-items-center" contenteditable="false">
						<a href="http://www.crystalimpact.com/" target="_blank">
							<img class="img-fluid p-3" src="images/logo-crystalimpact.png" />
						</a>
					</div>
					<div id="partners-content3" class="col d-flex align-items-center" contenteditable="false">
						<a href="http://www.peakscience.cn" target="_blank">
							<img class="img-fluid p-3" src="images/logo-peakscience.png" />
						</a>
					</div>
				</div>
				<div class="row">
					<div id="partners-content3" class="col d-flex align-items-center" contenteditable="false">
						<a href="http://www.quantum-rx.com/" target="_blank">
							<img class="img-fluid p-3" src="images/logo-quantum.png" />
						</a>
					</div>
					<div id="partners-content3" class="col d-flex align-items-center" contenteditable="false">
						<a href="http://www.teksercorp.com/" target="_blank">
							<img class="img-fluid p-3" src="images/logo-tekser.svg" />
						</a>
					</div>
					<!-- <div id="partners-content3" class="col d-flex align-items-center" contenteditable="false">
						<a href="http://www.xrfsco.com/" target="_blank">
							<img class="img-fluid p-3" src="images/logo-xrfsco.png" />
						</a>
					</div> -->
					<div id="partners-content3" class="col d-flex align-items-center" contenteditable="false">
						<a href="http://www.advatex.ru/" target="_blank">
							<img class="img-fluid p-3" src="images/logo-advatex.png" />
						</a>
					</div>
				</div>
			</div>
		</section>

		<section class="pt-60" id="contact">
			<div class="container">
				<div id="contact" class="row">
					<div class="col-md-12">
						<h1>CONTACT</h1>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4 offset-md-1">
						xplorex GmbH
						<br />Sommerstraße 4
						<br />D-83253 Rimsting am Chiemsee
						<br />Germany
						<br />
						<br />Sales Office:
						<br />Fonteinkruid 13
						<br />4617 JE Bergen op Zoom
						<br />The Netherlands
						<br />bert.kinneging@xplorex.eu
						<br />Mobile: +31 (0) 6 82 76 56 86
						<br />
						<br />Registergericht: Traunstein HRB24469
						<br />UStID: DE301209255
						<br />
						<br />Geschäftsführer:
						<br />- Norman Huber
						<br />- Bert Kinneging
						<br />- Raymond Verbruggen
					</div>
					<div class="col-md-6 offset-md-1">
						<div class="embed-responsive embed-responsive-4by3">
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2675.667213365079!2d12.339859999999998!3d47.88476999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4776127d66d7e59d%3A0x89feb7e0330e8e3e!2sSommerstra%C3%9Fe+4%2C+83253+Rimsting%2C+Duitsland!5e0!3m2!1snl!2snl!4v1434727036160"
								frameborder="0"
								style="border:0"
							></iframe>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Modal Component -->
		<b-modal ref="videoModalRef" size="lg" :title="movieTitle" :hide-header="false" :hide-footer="true" @hide="stopMovie">
			<div class="embed-responsive embed-responsive-16by9">
				<iframe ref="iframe" class="embed-responsive-item" allowfullscreen="true"></iframe>
			</div>
		</b-modal>

		<!-- image gallery -->
		<!-- <gallery :images="images" :index="index" :options="{prevClass: 'prv'}" @close="index=null"></gallery> -->
	</div>
</template>

<script>
import axios from 'axios';
import { Carousel, Slide } from 'vue-carousel';

export default {
	data: () => ({
		baseUrl: '/db-sqlite.php',
		measurements0: [
			{
				title: 'Silicon sample',
				url: 'images/si.jpg'
			}
		],
		measurements1: [
			{
				title: 'Resolution',
				url: 'images/res1.jpg'
			},
			{
				title: 'Resolution',
				url: 'images/res2.jpg'
			}
		],
		measurements2: [
			{
				title: 'Halite sample',
				url: 'images/halite.jpg'
			},
			{
				title: 'Calcite sample',
				url: 'images/calcite.jpg'
			}
		],
		measurements3: [
			{
				title: 'TiO2 ssmple with traces of Rut',
				url: 'images/TiO2.jpg'
			},
			{
				title: 'TiO2 ssmple with traces of Rut',
				url: 'images/TiO2_Rut_Ana_Main_Peaks.jpg'
			}
		],
		images: [],
		movie: [
            // https://www.thewebtaylor.com/articles/how-to-get-a-youtube-videos-thumbnail-image-in-high-quality
			{
				title: 'xplorex Documentary',
				href: 'https://www.youtube.com/embed/1X1SFrOwY4o',
				poster: 'images/video0.jpg'
			},
			{
				title: 'High Resolution XRD Powder Diffraction',
				href: 'https://www.youtube.com/embed/AauFlzmMniA',
				poster: 'images/video1.jpg'
			},
			{
				title: 'The xplorex Team',
				href: 'https://www.youtube.com/embed/YZP33Er376Q',
				poster: 'images/video2.jpg'
			},
			{
				title: 'Brixlegg archeological site',
				href: 'https://www.youtube.com/embed/RN6ndxr8KYI',
				poster: 'images/video3.jpg'
			}
		],
		movieTitle: '',
		index: null,
		content: []
	}),

	components: {
		Carousel,
		Slide
	},

	created() {
		console.clear();
		this.images = this.movie2;
		axios
			.get(this.baseUrl + '/quark_table')
			.then(response => {
				this.content = response.data;
				for (var i = 0; i < this.content.length; i++) {
					//this.content[i].content = this.content[i].content.split('img-responsive').join('img-fluid');
					// this.content[i].content = this.content[i].content.replace(/<([^ >]+)[^>]*>/ig, '<$1>');
					// this.content[i].content = this.content[i].content.split('<table>').join('<table class="table  table-bordered">');
				}
				//console.log(this.content[0].content);
			})
			.catch(e => {
				// this.errors.push(e)
				console.log(e);
			});
	},

	methods: {
		quarkRead(section) {
			var content;
			for (var i = 0; i < this.content.length; i++) {
				if (this.content[i].section == section) {
					content = this.content[i].content;
					break;
				}
			}

			return content;
		},

		// event handler for input blur
		edited(index) {
			// console.log(index, this.content[index].data1);
			// this.updateRow('data', this.content[index]);
			// this.total = this.calctotal(this.content);
		},

		// update row in database
		updateRow(table, row) {
			var config = {
				headers: {
					'X-HTTP-Method-Override': 'PUT'
				}
			};

			var url = this.baseUrl + table + '/' + row.id;
			axios
				.post(url, row, config)
				.then(function(response) {
					console.log(response);
				})
				.catch(function(error) {
					console.log(error);
				});
		},

		playMovie(movieNr) {
			this.$refs.iframe.src = this.movie[movieNr].href;
			this.movieTitle = this.movie[movieNr].title;
			this.$refs.videoModalRef.show();
		},

		stopMovie() {
			// stop movie by setting the iframe's src attribute
			this.$refs.iframe.src = '';
		},

		showGallery(index) {
			this.images = [];
			this.images.push(this.measurements[index]);
			this.index = 0;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-top {
	margin-top: 20px;
	width: 170px;
	/* max-width: 170px; */
	z-index: 10;
}

.planet-top {
	/* margin-top: 230px; */
	margin-top: 20px;
	width: 350px;
	/* max-width: 350px; */
	z-index: 10;
}

.navbar {
	padding-top: 0;
	padding-bottom: 0;
}

.navbar-font {
	font-family: 'avalon_xlight', sans-serif;
	font-size: 24px;
	font-weight: bold;
	letter-spacing: 2px;
}

.editor-font {
	font-family: 'avalon_xlight', sans-serif;
	font-size: 16px;
	/*font-weight: bold;*/
}

.foto1 {
	display: block;
	overflow: auto;
	background-image: url(/images/foto1_crop.jpg);
	background-repeat: no-repeat;
	background-position-x: center;
}

.foto2 {
	height: 370px;
	background-image: url(/images/foto2.jpg);
	background-repeat: no-repeat;
	background-position-x: center;
}

.foto3 {
	height: 370px;
	background-image: url(/images/foto3.jpg);
	background-repeat: no-repeat;
}

.foto4 {
	height: 370px;
	background-image: url(/images/foto4.jpg);
	background-repeat: no-repeat;
	background-position-x: center;
}

.pt-60 {
	padding-top: 60px;
}

.altWrap {
	border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;
	background-color: #f7f7f7;
}

.v-gallery .light-gallery a .image-container {
	background-color: white;
}
</style>
